import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { __fetchPlans } from "../../../../api/plan";

import DataTable from "../../../common/DataTable";
import useAxios from "../../../../hooks/useAxios";
import { Box } from "@mui/system";
import Title from "../../../common/Title";
import { Button, Grid, Stack } from "@mui/material";

const Plan = () => {
  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    {
      field: "plan_name",
      headerName: "Plan Name",
      flex: 3,
    },
    {
      field: "voice_enabled",
      headerName: "Voice Enabled",
      flex: 2,
      valueGetter: (params) => (params.row.voice_enabled ? "Yes" : "No"),
    },
    {
      field: "text_enabled",
      headerName: "Text Enabled",
      flex: 2,
      valueGetter: (params) => (params.row.text_enabled ? "Yes" : "No"),
    },
    {
      field: "value_unit",
      headerName: "Value Unit",
      flex: 2,
    },
    {
      field: "package_id",
      headerName: "Package ID",
      flex: 2,
    },
    {
      field: "notify_value",
      headerName: "Notify Value",
      flex: 2,
    },
    {
      field: "throttle_value",
      headerName: "Throttle Value",
      flex: 2,
    },
    {
      field: "throttle_speed",
      headerName: "Throttle Speed",
      flex: 2,
    },
    {
      field: "limit_value",
      headerName: "Limit Value",
      flex: 2,
    },
  ];

  const nav = useNavigate();
  const [data, setData] = useState([]);

  const [metaData, setMetaData] = useState({
    page: 1,
    page_size: 100,
    total: 1,
  });
  const [response, call, loading] = useAxios({ ...__fetchPlans });

  useEffect(() => {
    call({ params: { page: 1, page_size: 10000 } });
  }, []);

  useEffect(() => {
    if (response && response.status) {
      setMetaData({
        page: response.data.page,
        page_size: response.data.page_size,
        total: response.data.total,
      });
      setData(response.data.data);
    }
  }, [response]);

  return (
    <Box sx={{ width: "100%" }}>
      <Title variant="h5" content={`Plans`} gutterBottom />
      <Grid container justifyContent="flex-start" spacing={2}>
        <Grid item sx={{ mb: "10px" }}>
          <Stack spacing={2} direction="row">
            <Button
              variant="contained"
              color="primary"
              disabled={loading}
              onClick={() => nav("create")}
            >
              Create Plan
            </Button>
          </Stack>
        </Grid>
      </Grid>
      <DataTable
        disableColumnFilter
        loading={loading}
        data={data}
        columns={columns}
        metaData={{ ...metaData, page_size: 100 }}
        filterMode={"client"}
        handleRowClick={(params) => nav(`${params.id}`)}
      />
    </Box>
  );
};

export default Plan;

